module.exports = __webpack_public_path__ + "img/question.d2677323.svg";